import { render, staticRenderFns } from "./SFTP.vue?vue&type=template&id=6d5ee9c7&"
import script from "./SFTP.vue?vue&type=script&lang=js&"
export * from "./SFTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports